import React, { useEffect, useRef, useState } from "react";

import { Container } from 'react-bootstrap';
import Carousel from "react-bootstrap/Carousel";

import {
    Banner,
    ContainerTicketData,
    ContainerContent,
    SearchTicket,
    CheckboxContainer
} from "./styles";

import {search_option} from 'utils/Safra'

import { useNavigate, useLocation } from "react-router-dom";

import Button from "components/Safra/Button";
import SearchCar from "components/SearchCar";
import SearchHotel from "components/Safra/SearchHotel";
import SearchAirfare from "../../../components/Safra/SearchAirfare";
import Footer from "components/Safra/Footer";
import ValidationModal from "components/Safra/ValidationModal";
import WelcomeModal from "components/Safra/WelcomeModal";
import api from "../../../_config/http";
import { LoaderSearchImage } from "components/Safra/Loader";
import {
    trackSearchButtonClick,
    trackSearchSuccess,
    trackSearchError,
    trackValidationError,
    trackHotelSearch,
    trackFlightSearch,
    trackBannerClick,
    trackBannerImpression
} from "../../../utils/analytics";
import { useApp } from "../../../contexts/AppContext";
import { useAuth } from "../../../contexts/Safra/AuthProvider";
import { useEvents } from "../../../contexts/Safra/EventsProvider";
import { useTranslation } from "../../../contexts/Safra/TranslationContext";
import { changeDatesHotelAction, changeGuestsAction, changeLocationsHotelAction, clearSearch, changeHotelNameAction, changeOfferHotelAction } from "../../../contexts/reducers/hotels/actions";
import { clearDestinationAirport, clearOriginAirport } from "../../../utils/airportStorage";
import { RadioComponent } from "components/Safra/Radio";

import config from "_config/config";

export default function Home() {
    useEffect(() => {
        clearOriginAirport();
        clearDestinationAirport();

        localStorage.setItem('from-code', '');
        localStorage.setItem('from-main-code', '');
        localStorage.setItem('from-country-code', '');
        localStorage.setItem('from-city-code', '');
        localStorage.setItem('to-code', '');
        localStorage.setItem('to-main-code', '');
        localStorage.setItem('to-country-code', '');
        localStorage.setItem('to-city-code', '');
        localStorage.setItem('adults', '');
        localStorage.setItem('children', '');
        localStorage.setItem('baby', '');
        localStorage.setItem('class', '');
        localStorage.setItem('cabin', '');
        localStorage.setItem('radio-class', '');
        localStorage.setItem('onlyDeparture', 'false')
        localStorage.setItem('type', '1');
        localStorage.setItem('trip_type', '1');
        localStorage.setItem('from-date', '');
        localStorage.setItem('from_date', '');
        localStorage.setItem('from-date-formatted', '');
        localStorage.setItem('to-date', '');
        localStorage.setItem('to_date', '');
        localStorage.setItem('to-date-formatted', '');
    }, []);

    const [selected, setSelected] = useState('compra_passagem');
    const [showValidationModal, setShowValidationModal] = useState(false);
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
    const [missingFields, setMissingFields] = useState([]);
    const [originDestError, setOriginDestError] = useState('');
    const [hasOrigem, setHasOrigem] = useState(Boolean(localStorage.getItem('from-code') || localStorage.getItem('from-main-code')));
    const [hasDestino, setHasDestino] = useState(Boolean(localStorage.getItem('to-code') || localStorage.getItem('to-main-code')));
    const [isLoading] = useState(false);
    const location = useLocation()
    const viewedBannersRef = useRef(new Set());

    const navigate = useNavigate()
    const { customerId } = useAuth();
    const { t } = useTranslation();
    const { redirectResult, clearRedirectResult } = useEvents() || {};
    const { hotelState, hotelDispatch, carDispatch } = useApp();
    const { hotelNameSearch } = hotelState;

    useEffect(() => {
        hotelDispatch(clearSearch());
    }, [hotelDispatch, carDispatch]);

    const normalizePercentage = (value) => {
        if (value === null || value === undefined) return 0;

        let cleaned = String(value)
            .replace('%', '')
            .replace(',', '')
            .trim();

        let num = Number(cleaned);

        if (isNaN(num)) return 0;

        return num / 100;
    }

    useEffect(() => {
        api.post('/hotel/check-welcome-seen', { customer_uid: customerId || '' })
            .then(response => {
                if (response.data.status === 'success' && !response.data.was_seen) {
                    setShowWelcomeModal(true);
                }
            })
            .catch(error => console.error(error))
        const channel = localStorage.getItem('channel') || 'safra';
        config.get(`whitelabels/byChannel/${channel}`)
            .then(response => {
                localStorage.setItem('minimum_points_payment_percentage_hotel', normalizePercentage(response?.data?.data?.config?.percentual_minimo_pagamento_pontos));
                localStorage.setItem('minimum_points_purchase_hotel', response?.data?.data?.config?.valor_minimo_pontos_utilizado_compra)
                localStorage.setItem('minimum_points_payment_percentage_aereo', normalizePercentage(response?.data?.data?.config?.safra_min_purchase_aereo));
                localStorage.setItem('minimum_value_purchase_aereo', response?.data?.data?.config?.safra_min_value_aereo);
                const paymentMode = (response?.data?.data?.config?.payment_mode || 'points').toLowerCase();
                localStorage.setItem('payment_mode', paymentMode);
                hotelDispatch(changeOfferHotelAction(paymentMode === 'money' ? 'cash' : 'points'));
            })
            .catch(error => {
                console.error('Error fetching config channel:', error);
                return { status: false };
            });
    }, []);

    const handleCloseWelcomeModal = () => {
        setShowWelcomeModal(false);
    };

    const handleCloseValidationModal = () => {
        setShowValidationModal(false);
    };

    useEffect(() => {
        const syncHeight = () => {

            const height = document.body.scrollHeight;
            window.parent.postMessage(height, '*')
        };

        setTimeout(syncHeight, 1000);

    }, [])

    useEffect(() => {
        const handler = () => {
            setHasOrigem(Boolean(localStorage.getItem('from-code') || localStorage.getItem('from-main-code')));
            setHasDestino(Boolean(localStorage.getItem('to-code') || localStorage.getItem('to-main-code')));
        };
        window.addEventListener('safra-airport-change', handler);
        return () => window.removeEventListener('safra-airport-change', handler);
    }, []);

    const clearValidationErrors = () => {
        document.querySelectorAll('.validation-error').forEach(el => el.classList.remove('validation-error'));
        document.querySelectorAll('.validation-error-message').forEach(el => el.remove());
    }

    const clearFieldError = (element) => {
        if (!element) return;

        const inputGroup = element.closest('.input-group') || element.closest('.content-custom');
        if (inputGroup) {
            inputGroup.classList.remove('validation-error');
            const errorMsg = inputGroup.parentNode.querySelector('.validation-error-message');
            if (errorMsg) {
                errorMsg.remove();
            }
        }
    }

    const addValidationError = (element) => {
        if (!element) return;

        const inputGroup = element.closest('.input-group') || element.closest('.content-custom');
        if (inputGroup) {
            inputGroup.classList.add('validation-error');

            if (!inputGroup.parentNode.querySelector('.validation-error-message')) {
                const errorMsg = document.createElement('div');
                errorMsg.className = 'validation-error-message';
                errorMsg.textContent = t('safra.home.validation_required');
                inputGroup.parentNode.insertBefore(errorMsg, inputGroup.nextSibling);
            }
        }
    }

    useEffect(() => {
        const setupFieldListeners = () => {
            const hotLocation = document.getElementById('hotLocation');
            const hotCheckin = document.getElementById('passCheckin');
            const hotCheckout = document.getElementById('passCheckout');

            if (hotLocation) {
                hotLocation.addEventListener('input', () => {
                    if (hotLocation.value !== '') {
                        clearFieldError(hotLocation);
                    }
                });
                hotLocation.addEventListener('change', () => {
                    if (hotLocation.value !== '') {
                        clearFieldError(hotLocation);
                    }
                });
            }

            if (hotCheckin) {
                hotCheckin.addEventListener('change', () => {
                    if (hotCheckin.value !== '') {
                        clearFieldError(hotCheckin);
                    }
                });
            }

            if (hotCheckout) {
                hotCheckout.addEventListener('change', () => {
                    if (hotCheckout.value !== '') {
                        clearFieldError(hotCheckout);
                    }
                });
            }
        };

        const timer = setTimeout(setupFieldListeners, 500);
        return () => clearTimeout(timer);
    }, [selected]);

    const handleSearchHotels = (bannerTrigged = false) => {
        clearValidationErrors();

        const hotCheckin = document.getElementById('passCheckin')
        const hotCheckout = document.getElementById('passCheckout')
        const hotLocation = document.getElementById('hotLocation')

        const missing = [];

        const hotCheckinValue = (hotCheckin?.value ?? hotCheckin?.textContent ?? '').trim();
        const hotCheckoutValue = (hotCheckout?.value ?? hotCheckout?.textContent ?? '').trim();
        const isHotCheckinEmpty = hotCheckinValue === '' || hotCheckinValue === 'Check-in';
        const isHotCheckoutEmpty = hotCheckoutValue === '' || hotCheckoutValue === 'Check-out';

        const searchParams = {
            destination: hotLocation?.value || '',
            startDate: isHotCheckinEmpty ? '' : hotCheckinValue,
            endDate: isHotCheckoutEmpty ? '' : hotCheckoutValue,
            occupants: false
        };

        if (!hotLocation || hotLocation.value === '') {
            missing.push(t('safra.home.fields.destination'));
            addValidationError(hotLocation);
        }
        if (!hotCheckin || isHotCheckinEmpty) {
            missing.push(t('safra.home.fields.checkin'));
            addValidationError(hotCheckin);
        }
        if (!hotCheckout || isHotCheckoutEmpty) {
            missing.push(t('safra.home.fields.checkout'));
            addValidationError(hotCheckout);
        }

        const adultsElement = document.getElementById('qtd_adults');
        const childrenElement = document.getElementById('qtd_children');

        let totalGuests = 0;
        let adults = 0;
        let children = 0;
        if (adultsElement) {
            adults = parseInt(adultsElement.textContent) || 0;
            totalGuests += adults;
        }
        if (childrenElement) {
            children = parseInt(childrenElement.textContent) || 0;
            totalGuests += children;
        }

        searchParams.occupants = totalGuests > 0;

        if (totalGuests === 0) {
            missing.push(t('safra.home.fields.guests'));
            const roomQuantityContainer = document.getElementById('room-quantity-container');
            if (roomQuantityContainer) {
                const inputGroup = roomQuantityContainer.querySelector('.input-group');
                if (inputGroup) {
                    inputGroup.classList.add('validation-error');
                }
                if (!roomQuantityContainer.querySelector('.validation-error-message')) {
                    const errorMsg = document.createElement('div');
                    errorMsg.className = 'validation-error-message';
                    errorMsg.textContent = t('safra.home.validation_required');
                    roomQuantityContainer.appendChild(errorMsg);
                }
            }
        }

        if (!bannerTrigged) {
            trackSearchButtonClick('hotel', searchParams);
        }

        if (missing.length > 0) {
            setMissingFields(missing);
            setShowValidationModal(true);

            missing.forEach(field => {
                trackValidationError('hotel', 'missing_field', `Campo obrigatório: ${field}`);
            });

            trackSearchError('hotel', 'validation_error', 'Campos obrigatórios não preenchidos', searchParams);

            return false;
        }

        const checkinDate = isHotCheckinEmpty ? '' : hotCheckinValue;
        const checkoutDate = isHotCheckoutEmpty ? '' : hotCheckoutValue;

        let nights = 0;
        if (checkinDate && checkoutDate) {
            const checkin = new Date(checkinDate.split('/').reverse().join('-'));
            const checkout = new Date(checkoutDate.split('/').reverse().join('-'));
            nights = Math.floor((checkout - checkin) / (1000 * 60 * 60 * 24));
        }

        trackSearchSuccess('hotel', {
            destination: hotLocation.value,
            checkinDate,
            checkoutDate,
            nights,
            rooms: 1,
            adults,
            children
        });

        trackHotelSearch({
            location: hotLocation.value,
            search_name: hotelNameSearch?.name?.trim() || '',
            check_in: checkinDate,
            check_out: checkoutDate,
            nights,
            hosts: totalGuests,
            adults,
            children
        });

        navigate('/hotels-search-result')
    }

    const handleSearchCars = () => {
        navigate('/cars-search-result')
    }

    const handleSearchHotelsClick = () => {
        handleSearchHotels();
    }

    const handleTicketsClick = () => {
        handleTickets();
    }

    const handleRadioSelect = (valueOrEvent) => {
        const value = typeof valueOrEvent === 'string'
            ? valueOrEvent
            : valueOrEvent?.target?.value;

        if (value) {
            setSelected(value);
        }
    }

    const handleRadioOptionClick = (e) => {
        handleRadioSelect(e);
    }


    useEffect(() => {

        const params = new URLSearchParams(location.search)

        if (!params.has('csrf')) {
            const radio = document.getElementById('radio1');
            if (radio) {
                radio.checked = true;
                radio.click();
            }

            setSelected(search_option[1].value)
        } else {
            localStorage.setItem('csrf_token', params.get('csrf'))
        }

    }, [])

    useEffect(() => {
        const elemento = document.body || document.documentElement;
        const height = elemento?.offsetHeight || elemento?.scrollHeight;

        if (height) {
            window.parent.postMessage(height, "*");
        }

    }, [])

    function handleTickets(bannerTrigged = false) {
        const passOrigem = document.getElementById('passOrigem')
        const passDestino = document.getElementById('passDestino')
        const passCheckin = document.getElementById('passCheckin')
        const passCheckout = document.getElementById('passCheckout')

        const chkIda = document.getElementById('chkIda')
        const onlyIdaChecked = Boolean(chkIda?.checked)

        const passOrigemValue = passOrigem?.value || ''
        const passDestinoValue = passDestino?.value || ''
        const passCheckinValue = (passCheckin?.value ?? passCheckin?.textContent ?? '').trim();
        const passCheckoutValue = (passCheckout?.value ?? passCheckout?.textContent ?? '').trim();
        const fromDateStored = (localStorage.getItem('from-date') || '').trim();
        const toDateStored = (localStorage.getItem('to-date') || '').trim();
        const isPassCheckinEmpty = fromDateStored === '' || passCheckinValue === '' || passCheckinValue === 'Ida' || passCheckinValue === 'Data de ida';
        const isPassCheckoutEmpty = toDateStored === '' || passCheckoutValue === '' || passCheckoutValue === 'Volta' || passCheckoutValue === 'Data de volta';

        clearValidationErrors();
        setOriginDestError('');

        const searchParams = {
            origin: passOrigemValue,
            destination: passDestinoValue,
            startDate: isPassCheckinEmpty ? '' : passCheckinValue,
            endDate: isPassCheckoutEmpty ? '' : passCheckoutValue,
            occupants: false
        };

        const fromCode = (localStorage.getItem('from-code') || localStorage.getItem('from-main-code') || '').trim().toLowerCase();
        const toCode = (localStorage.getItem('to-code') || localStorage.getItem('to-main-code') || '').trim().toLowerCase();

        const normalize = (value) => value
            ? value.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/gu, '')
            : '';

        const sameCode = fromCode && toCode && fromCode === toCode;
        const sameLabel = normalize(passOrigemValue) && normalize(passDestinoValue) && normalize(passOrigemValue) === normalize(passDestinoValue);

        if (sameCode || sameLabel) {
            setOriginDestError(t('safra.home.error_same_origin_dest'));
            addValidationError(passOrigem);
            addValidationError(passDestino);

            trackValidationError('flight', 'same_origin_destination', t('safra.home.error_same_origin_dest'));
            trackSearchError('flight', 'same_origin_destination', t('safra.home.error_same_origin_dest'), searchParams);

            return false;
        }

        const missing = [];

        if (passOrigemValue === '') {
            missing.push(t('safra.home.fields.origin'));
            addValidationError(passOrigem);
        }
        if (passDestinoValue === '') {
            missing.push(t('safra.home.fields.destination'));
            addValidationError(passDestino);
        }
        if (isPassCheckinEmpty) {
            missing.push(t('safra.home.fields.departure'));
            addValidationError(passCheckin);
        }
        if (!onlyIdaChecked && isPassCheckoutEmpty) {
            missing.push(t('safra.home.fields.return'));
            addValidationError(passCheckout);
        }

        const passageirosInput = document.getElementById('passPassengers');
        const passageirosValue = passageirosInput ? passageirosInput.value.trim() : '';
        const adultsStored = parseInt(localStorage.getItem('adults') || '0', 10);
        const childrenStored = parseInt(localStorage.getItem('children') || '0', 10);
        const babyStored = parseInt(localStorage.getItem('baby') || '0', 10);
        const totalPassengersStored = Math.max(0, adultsStored) + Math.max(0, childrenStored) + Math.max(0, babyStored);

        if (passageirosValue === '' && totalPassengersStored === 0) {
            missing.push(t('safra.home.fields.passengers'));
            addValidationError(passageirosInput);
        } else {
            searchParams.occupants = true;
        }

        const classeInput = document.getElementById('passClass');
        const classeValue = classeInput ? classeInput.value.trim() : '';
        const classStored = localStorage.getItem('class') || localStorage.getItem('cabin') || localStorage.getItem('radio-class') || '';

        if (classeValue === '' && classStored === '') {
            missing.push(t('safra.home.fields.class'));
            addValidationError(classeInput);
        }

        if (!bannerTrigged) {
            trackFlightSearch({
                departure: passOrigemValue,
                arrival: passDestinoValue,
                depating: passCheckinValue,
                returning: onlyIdaChecked ? '' : passCheckoutValue,
                passengers: totalPassengersStored,
                class: classeValue,
                type: onlyIdaChecked ? 'Ida' : 'Retorno',
                adults: adultsStored,
                children: childrenStored,
                baby: babyStored
            });

            trackSearchButtonClick('flight', searchParams);
        }

        if (missing.length > 0) {
            setMissingFields(missing);
            setShowValidationModal(true);

            missing.forEach(field => {
                trackValidationError('flight', 'missing_field', `Campo obrigatório: ${field}`);
            });

            trackSearchError('flight', 'validation_error', 'Campos obrigatórios não preenchidos', searchParams);

            return false;
        }

        localStorage.setItem('modulo', '1');
        localStorage.setItem('type', '1');
        localStorage.setItem('direct', '0');

        try {
            localStorage.setItem('onlyDeparture', onlyIdaChecked ? 'true' : 'false')
        } catch (err) {
            console.error('Error setting localStorage items for onlyDeparture:', err);
        }

        try {
            localStorage.setItem('type', onlyIdaChecked ? '2' : '1');
            localStorage.setItem('trip_type', onlyIdaChecked ? '2' : '1');

            localStorage.setItem('trip_type-item', onlyIdaChecked ? '' : '2');

            const fd = localStorage.getItem('from-date') || '';
            const td = localStorage.getItem('to-date') || '';
            localStorage.setItem('from_date', fd);
            localStorage.setItem('to_date', td);

            const adults = Math.max(1, parseInt(localStorage.getItem('adults') || '1', 10));
            const children = Math.max(0, parseInt(localStorage.getItem('children') || '0', 10));
            const baby = Math.max(0, parseInt(localStorage.getItem('baby') || '0', 10));

            localStorage.setItem('adults', String(adults));
            localStorage.setItem('children', String(children));
            localStorage.setItem('baby', String(baby));

            localStorage.setItem('adults-item', String(adults));
            localStorage.setItem('children-item', String(children));
            localStorage.setItem('baby-item', String(baby));

            const cls = localStorage.getItem('class') || localStorage.getItem('radio-class') || 'economy';
            localStorage.setItem('class', cls);
            localStorage.setItem('cabin', cls);

            const localPayload = {
                origin: fromCode,
                destination: toCode,
                departureDate: passCheckinValue,
                returnDate: onlyIdaChecked ? '' : passCheckoutValue,
                class: classeValue,
                adults,
                children,
                infants: baby,
                tripType: onlyIdaChecked ? 'oneway' : 'roundtrip',
                originName: decodeURIComponent(localStorage.getItem('from-name') || ''),
                destinationName: decodeURIComponent(localStorage.getItem('to-name') || ''),
                originCityCode: localStorage.getItem('from-city-code') || '',
                destinationCityCode: localStorage.getItem('to-city-code') || ''
            };

            const trackPayload = {
                origin: fromCode,
                destination: toCode,
                departureDate: passCheckinValue,
                returnDate: onlyIdaChecked ? '' : passCheckoutValue,
                class: classeValue,
                adults,
                children,
                infants: baby,
                tripType: onlyIdaChecked ? 'oneway' : 'roundtrip'
            }

            trackSearchSuccess('flight', trackPayload);

            const key = 'trackSearchSuccessHistory';
            const current = JSON.parse(localStorage.getItem(key) || '[]');
            const list = Array.isArray(current) ? current : [];
            if (list.length >= 3) list.splice(0, 1);
            list.push(localPayload);
            localStorage.setItem(key, JSON.stringify(list));

        } catch (err) {
            console.error('Error setting localStorage items for ticket search:', err);
        }

        navigate('/passage-search-result')
    }


    const [isBannerReady, setIsBannerReady] = useState(false);
    const [isProcessingRedirect, setIsProcessingRedirect] = useState(
        () => new URLSearchParams(window.location.search).has('bannerRedirect')
    );
    const [validBanners, setValidBanners] = useState([]);


    const buildBannerSrc = (item) => {
        if (!item?.uuid || !item?.extension) {
            return null;
        }

        return `${process.env.REACT_APP_SAFRA_BANNER_LINKS}/media/bannerCarrossel/slide/${item.uuid}.${item.extension}`;
    }

    const handleDatePattern = (date) => {
        return date.split('-').reverse().join('/');
    };

    const parseISODateLocal = (dateString) => {
        if (!dateString || typeof dateString !== 'string') return null;
        if (dateString.includes('T')) {
            const parsed = new Date(dateString);
            return Number.isNaN(parsed.getTime()) ? null : parsed;
        }
        const [year, month, day] = dateString.split('-').map(Number);
        if (!year || !month || !day) return null;
        return new Date(year, month - 1, day);
    };

    const triggerInput = (el) => {
        if (!el) return;
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const resolveSearchOptionValue = (bannerType) => {
        if (!Array.isArray(search_option)) return null;

        const normalizedType = bannerType.toLowerCase();

        const option = search_option.find(opt =>
            opt.label.toLowerCase() === normalizedType ||
            opt.value.toLowerCase().includes(normalizedType)
        );

        return option?.value || null;
    };

    const applyFlightBannerData = (data) => {
        clearOriginAirport();
        
        localStorage.setItem('from-code', data.origem.code);
        localStorage.setItem('from-main-code', data.origem.mainCode);
        localStorage.setItem('from-country-code', data.origem.countryCode);
        localStorage.setItem('from-name', data.origem.name);
        localStorage.setItem('from', data.origem.name);

        clearDestinationAirport();
        
        localStorage.setItem('to-code', data.destino.code);
        localStorage.setItem('to-main-code', data.destino.mainCode);
        localStorage.setItem('to-country-code', data.destino.countryCode);
        localStorage.setItem('to-name', data.destino.name);
        localStorage.setItem('to', data.destino.name);

        localStorage.setItem('from-date', data.from_date);
        localStorage.setItem('from_date', data.from_date);
        localStorage.setItem('from-date-formatted', handleDatePattern(data.from_date));

        if (!data.onlyIda) {
            localStorage.setItem('to-date', data.to_date);
            localStorage.setItem('to-date-formatted', handleDatePattern(data.to_date));
            localStorage.setItem('to_date', data.to_date);
        }

        localStorage.setItem('adults', String(data.adults));
        localStorage.setItem('children', String(data.children));
        localStorage.setItem('baby', String(data.baby));

        localStorage.setItem('class', data.class);
        localStorage.setItem('cabin', data.class);

        localStorage.setItem('onlyDeparture', data.onlyIda ? 'true' : 'false');
        localStorage.setItem('trip_type', data.onlyIda ? '2' : '1');
        localStorage.setItem('type', data.onlyIda ? '2' : '1');
        localStorage.setItem('modulo', '1');
        localStorage.setItem('direct', '0');
    };

    const applyHotelBannerData = (data) => {
        const adults = data.travellers.filter(t => t.ageGroup === 'adult').length;
        const children = data.travellers.filter(t => t.ageGroup === 'child').length;

        localStorage.setItem('from-date', data.checkIn);
        localStorage.setItem('from-date-formatted', handleDatePattern(data.checkIn));
        localStorage.setItem('to-date', data.checkOut);
        localStorage.setItem('to_date', data.checkOut);
        localStorage.setItem('to-date-formatted', handleDatePattern(data.checkOut));

        localStorage.setItem('adults', String(adults));
        localStorage.setItem('children', String(children));
        localStorage.setItem('baby', '0');
        localStorage.setItem('hotLocation', data.locationName);
        localStorage.setItem('hotLocationId', data.locationId);

        hotelDispatch(changeDatesHotelAction([{
            startDate: parseISODateLocal(data.checkIn),
            endDate: parseISODateLocal(data.checkOut)
        }]));
        hotelDispatch(changeGuestsAction({ adults, children }));
        hotelDispatch(changeLocationsHotelAction({ id: data.locationId, name: data.locationName }));

        if (data.hotelName) {
            hotelDispatch(changeHotelNameAction({ name: data.hotelName }));
        }
    };

    const handleBannerClick = async (item) => {
        const link = item?.link;
        if (!link) return;
        
        handleRadioSelect(resolveSearchOptionValue(link.bannerType));
        await new Promise(r => setTimeout(r, 0));
        
        if (link.bannerType === 'passagem' && link.data) {
            const { data } = link;

            trackBannerClick({
                index: item.index,
                urlImage: item.url,
                contentType: link.bannerType,
                departure: data.origem.name,
                arrival: data.destino?.name,
                depating: data.from_date,
                returning: data.to_date,
                class: data.class,
                type: data.onlyIda ? 'Ida' : 'Retorno',
                adults: data.adults,
                children: data.children,
                baby: data.baby
            })
            
            const origemEl = document.getElementById('passOrigem');
            const destinoEl = document.getElementById('passDestino');

            if (origemEl) {
                origemEl.value = data.origem.name;
                triggerInput(origemEl);
            }

            if (destinoEl) {
                destinoEl.value = data.destino.name;
                triggerInput(destinoEl);
            }

            const checkinEl = document.getElementById('passCheckin');
            const checkoutEl = document.getElementById('passCheckout');

            if (checkinEl) {
                checkinEl.value = handleDatePattern(data.from_date);
                triggerInput(checkinEl);
            }
            const chkIda = document.getElementById('chkIda');
            if (chkIda) {
                chkIda.checked = Boolean(data.onlyIda);
                triggerInput(chkIda);
            }

            if (!data.onlyIda && checkoutEl) {
                checkoutEl.value = handleDatePattern(data.to_date);
                triggerInput(checkoutEl);
            }

            applyFlightBannerData(data);
            handleTickets(true);
        }

        if (link.bannerType === 'hotel' && link.data) {
            const data = link.data;

            trackBannerClick({
                index: item.index,
                urlImage: item.url,
                contentType: link.bannerType,
                location: data.locationName,
                search_name: data.hotelName || '',
                check_in: data.checkIn,
                check_out: data.checkOut,
                nights: '',
                hosts: data.travellers?.length || 0
            });

            const checkinEl = document.getElementById('passCheckin');
            const checkoutEl = document.getElementById('passCheckout');

            if (checkinEl) {
                checkinEl.value = handleDatePattern(data.checkIn);
                triggerInput(checkinEl);
            }

            if (checkoutEl) {
                checkoutEl.value = handleDatePattern(data.checkOut);
                triggerInput(checkoutEl);
            }

            const hotLocation = document.getElementById('hotLocation');
            if (hotLocation) {
                hotLocation.value = data.locationName;
                triggerInput(hotLocation);
            }

            const adults = data.travellers.filter(t => t.ageGroup === 'adult').length;
            const children = data.travellers.filter(t => t.ageGroup === 'child').length;

            const adultsEl = document.getElementById('qtd_adults');
            const childrenEl = document.getElementById('qtd_children');

            if (adultsEl) adultsEl.textContent = adults;
            if (childrenEl) childrenEl.textContent = children;

            applyHotelBannerData(data);
            handleSearchHotels(true);
        }
    };

    const parseLinkSafely = (link) => {
        if (!link || typeof link !== 'string') return null;

        try {
            return JSON.parse(link);
        } catch {
            const decoded = document.createElement('textarea');
            decoded.innerHTML = link;

            try {
                return JSON.parse(decoded.value);
            } catch {
                console.error('Link inválido:', link);
                return null;
            }
        }
    }


    useEffect(() => {
        let cancelled = false;

        api.post('/hotels/banner', { channel: "safra-hotel" })
            .then(response => {
                if (response.status !== 200) return;

                const payload = response.data;
                const items = Array.isArray(payload)
                    ? payload
                    : (Array.isArray(payload?.data) ? payload.data : []);
                const filtered = items.filter(i => i?.uuid && i?.extension);

                setIsBannerReady(false);

                if (filtered.length === 0) {
                    setValidBanners([]);
                    setIsBannerReady(true);
                    return;
                }

                const preloadOne = (item) =>
                    new Promise(resolve => {
                        const img = new Image();
                        img.onload = () => resolve({
                            item: {
                                ...item,
                                link: parseLinkSafely(item.link),
                            }, ok: true
                        });
                        img.onerror = () => resolve({ item, ok: false });
                        img.src = buildBannerSrc(item);
                    });

                Promise.all(filtered.map(preloadOne)).then(results => {
                    if (cancelled) return;

                    const okItems = results.filter(r => r.ok).map(r => r.item);

                    setValidBanners(okItems);
                    setIsBannerReady(true);
                });
            })
            .catch(() => {
                if (!cancelled) {
                    setValidBanners([]);
                    setIsBannerReady(true);
                }
            });

        return () => { cancelled = true; };
    }, []);

    const handleTrackImpression = (bannerIndex) => {
        const selectedBanner = validBanners[bannerIndex];

        if (!selectedBanner?.uuid) {
            return;
        }

        if (viewedBannersRef.current.has(selectedBanner.uuid)) {
            return;
        }

        viewedBannersRef.current.add(selectedBanner.uuid);

        let contentType = '';
        const trackData = {};

        if (selectedBanner.link?.bannerType === 'passagem') {
            const { data } = selectedBanner.link;
            contentType = selectedBanner.link.bannerType;
            trackData.departure = data.origem.name;
            trackData.arrival = data.destino?.name;
            trackData.depating = data.from_date;
            trackData.returning = data.to_date;
            trackData.classType = data.class;
            trackData.type = data.onlyIda ? 'Ida' : 'Retorno';
            trackData.adults = data.adults;
            trackData.children = data.children;
            trackData.baby = data.baby
        }

        if (selectedBanner.link?.bannerType === 'hotel') {
            const { data } = selectedBanner.link;
            contentType = selectedBanner.link.bannerType;
            trackData.location = data.locationName;
            trackData.check_in = data.checkIn;
            trackData.check_out = data.checkOut;
            trackData.adults = data.travellers.length;
            trackData.children = 0;
            trackData.baby = 0;

        }

        trackBannerImpression({
            index: bannerIndex,
            urlImage: buildBannerSrc(selectedBanner),
            contentType,
            ...trackData,
        })
    }

    useEffect(() => {
        if (isBannerReady && validBanners.length > 0) {
            handleTrackImpression(0);
        }
    }, [isBannerReady, validBanners]);

    useEffect(() => {
        if (!redirectResult) return;

        setIsProcessingRedirect(true);

        const { result_type, bannerData } = redirectResult;
        clearRedirectResult();

        if (!result_type || !bannerData) {
            setIsProcessingRedirect(false);
            return;
        }

        if (result_type === 'search_flight' && bannerData.origem) {
            applyFlightBannerData(bannerData);
            navigate('/passage-search-result');
        }

        if (result_type === 'search_hotel' && bannerData.locationId) {
            applyHotelBannerData(bannerData);
            navigate('/hotels-search-result');
        }
    }, [redirectResult]);

    const handleBannerCarouselClick = (e) => {
        const bannerIndex = Number(e.currentTarget.dataset.bannerIndex);
        const selectedBanner = validBanners[bannerIndex];
        selectedBanner.index = bannerIndex;
        
        if (selectedBanner?.link) {
            selectedBanner.url = buildBannerSrc(selectedBanner);
            handleBannerClick(selectedBanner);
        }
    }


    if (redirectResult || isProcessingRedirect) {
        return <LoaderSearchImage />;
    }

    return (
        <>
            {isLoading && <LoaderSearchImage />}
            <Banner >
                {isBannerReady ? (
                    <Carousel
                        variant="dark"
                        onSlid={(selectedIndex) => handleTrackImpression(selectedIndex)}
                    >
                        {validBanners.map((item, index) => (
                            item?.uuid && (
                                <Carousel.Item
                                    key={item.uuid}
                                    style={{ alignItems: "center", cursor: item.link ? 'pointer' : 'default' }}
                                    data-banner-index={index}
                                    onClick={handleBannerCarouselClick}
                                >
                                    <img
                                        className="d-block"
                                        src={buildBannerSrc(item)}
                                        alt={item.label}
                                        style={{ width: '100%', height: "auto" }}
                                    />
                                </Carousel.Item>
                            )
                        ))}
                    </Carousel>
                ) : (
                    <div style={{ width: '100%', aspectRatio: '16 / 9' }} aria-hidden="true" />
                )}
            </Banner>
            <Container>
                <ContainerTicketData>
                    <ContainerContent>
                        <SearchTicket>{t('safra.home.title')}</SearchTicket>
                        {originDestError && (
                            <div className="alert alert-danger mt-2" role="alert">
                                {originDestError}
                            </div>
                        )}
                        <CheckboxContainer>
                            {search_option.map((option, index) =>
                               <RadioComponent key={option.value || index} option={option} index={index} handleClick={handleRadioOptionClick}/>
                            )}
                        </CheckboxContainer>
                        {/*  -------------------------Pesquisa---------------------- */}
                        {selected === 'compra_passagem' &&
                            <>
                                <SearchAirfare />
                                <div className="text-center" style={{ marginTop: '32px' }}>
                                    <Button
                                        id="passage-search-cta"
                                        onClick={handleTicketsClick}
                                        width="100%"
                                        style={{ padding: '16px' }}
                                    >
                                        {t('safra.home.cta_passagens')}
                                    </Button>
                                </div>
                            </>
                        }
                        {selected === 'compra_hotel' &&
                            <>
                                <SearchHotel buttonLabel={t('common.continue')} />
                                <div className="w-100">
                                    <Button
                                        onClick={handleSearchHotelsClick}
                                        width="100%"
                                        style={{
                                            borderRadius: '4px',
                                            fontFamily: 'Montserrat, sans-serif',
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            letterSpacing: '0%',
                                            lineHeight: '100%',
                                            padding: '16px',
                                            marginTop: '16px'
                                        }}
                                    >
                                        {t('safra.home.cta_hoteis')}
                                    </Button>
                                </div>
                            </>
                        }

                        {selected === 'compra_carro' &&
                            <>
                                <SearchCar />
                                <div className="d-flex justify-content-center">
                                    <Button
                                        onClick={handleSearchCars}
                                        width="200px"
                                    >
                                        {t('safra.home.cta_carros')}
                                    </Button>
                                </div>
                            </>
                        }

                        {/*  -------------------------Pesquisa---------------------- */}
                    </ContainerContent>
                </ContainerTicketData>
            </Container>
            <ValidationModal
                isOpen={showValidationModal}
                onClose={handleCloseValidationModal}
                missingFields={missingFields}
            />
            <WelcomeModal
                isOpen={showWelcomeModal}
                onClose={handleCloseWelcomeModal}
            />
            <Footer />
        </>
    );
}
